import { c as _c } from "react/compiler-runtime";
import React from "react";
import { layoutEyebrowClasses, layoutHeaderClasses } from "@/components/tailwindHelpers";
import { colorSettingDetection, darkTextureWrapper, renderHeaderConditionally } from "../../utils/functions";
export interface LayoutRichTextProps {
  eyebrow?: string;
  title?: string;
  headerElement?: "h1" | "h2";
  body?: React.ReactNode;
  index?: number;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
}
export const LayoutRichText = t0 => {
  const $ = _c(23);
  const {
    eyebrow,
    title,
    headerElement: t1,
    body,
    index,
    presetTheme: t2
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const presetTheme = t2 === undefined ? "t2-theme-one" : t2;
  const t3 = title || "";
  let t4;
  if ($[0] !== headerElement || $[1] !== t3) {
    t4 = renderHeaderConditionally(layoutHeaderClasses, t3, headerElement);
    $[0] = headerElement;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const displayTitle = t4;
  let t5;
  if ($[3] !== presetTheme) {
    t5 = colorSettingDetection(presetTheme);
    $[3] = presetTheme;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const colorSetting = t5;
  let t6;
  if ($[5] !== presetTheme) {
    t6 = darkTextureWrapper(presetTheme);
    $[5] = presetTheme;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const componentStyles = t6;
  const t7 = `${presetTheme} ${colorSetting} py-[50px]`;
  let t8;
  if ($[7] !== eyebrow) {
    t8 = eyebrow ? <p className={layoutEyebrowClasses}>{eyebrow}</p> : null;
    $[7] = eyebrow;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== displayTitle || $[10] !== index || $[11] !== title) {
    t9 = title && <div id={index ? `layout-rich-text-${index}` : undefined}>{title ? displayTitle : null}</div>;
    $[9] = displayTitle;
    $[10] = index;
    $[11] = title;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== body) {
    t10 = body ? <div className="richtxt" data-testid="layout-rich-text-body">{body}</div> : null;
    $[13] = body;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = <div className="w-full px-5 lg:px-20 m-auto max-w-[1440px] t2-container">{t8}{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== componentStyles || $[20] !== t11 || $[21] !== t7) {
    t12 = <section className={t7} style={componentStyles} data-testid="layout-rich-text">{t11}</section>;
    $[19] = componentStyles;
    $[20] = t11;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};